<template>
    <div>
        <el-button type="text" @click="dialog = true; reset()">
            <i>改</i>
        </el-button>
        <el-dialog v-if="dialog" :visible.sync="dialog">
            <el-form ref="form" :model="fileinfo" label-width="120px">
                <!-- <el-form-item label="dscr_collection">
                    <el-input v-model="fileinfo.collection"></el-input>
                </el-form-item> -->
    
                <el-form-item label="PathInPublic">
                    <el-input  type="textarea" v-model="fileinfo.path"></el-input>
                </el-form-item>
            </el-form>

            <el-upload class="upload-demo" drag action :auto-upload="false" :on-change="handleChange"
                :on-remove="handleRemove" :multiple="false" :file-list="filelist">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">文件拖放到此替换</div>

                <!-- <el-button size="small" type="primary">点击上传</el-button> -->
            </el-upload>

            <el-button type="warning" @click="filechange">更改文件</el-button>
            <el-button type="danger" @dblclick.native="filedelete">删除文件</el-button>
        </el-dialog>

    </div>
</template>

<script>

export default {
    props: ["rowdata"],
    mounted() {

    },
    data() {
        return {
            filelist: [],
            // deletes: [],
            // thedata: { doc: [] }, //{ archive: [] },
            // dialogdelete: false,
            fileinfo: {"path":this.rowdata.path.replace(url,"")},
            dialog: false,
            // filelist: [],
            // formdata: new FormData()
        };
    },

    computed: {
        collection() { return this.$store.state.collection.value }
        // cat() {
        //   return this.$store.state.collections.filter(function(obj) {
        //     return !obj.value.includes("tempexcel");
        //   });
        // }
    },
    watch: {},
    methods: {
        handleChange(file, fileList) {
            this.filelist = fileList.slice(-1)
        },
        handleRemove(file, fileList) {
            this.filelist = fileList
        },
        // pathurlremove(obj){
        //     let fileinfo = JSON.parse(JSON.stringify(obj))
        //     fileinfo.path=fileinfo.path.replace(url,"")
        //     return  fileinfo
        // },
        reset() {
            this.fileinfo={"path":this.rowdata.path.replace(url,"")}
            // this.fileinfo=this.pathurlremove(this.rowdata)
            
        },
        filechange() {
            // console.log(this.filelist)
            const formdata = new FormData();
            // let oldfileinfo=this.pathurlremove(this.rowdata)
            //formdata 不能append object
            formdata.append("_id",this.rowdata._id)
            formdata.append("oldpath", this.rowdata.path.replace(url,""))
            formdata.append("newpath", this.fileinfo.path)

            if (this.filelist.length > 0) {
                formdata.append('file', this.filelist[0].raw);
            }
            // console.log(this.rowdata)
            // console.log(formdata.get('oldfileinfo'))
            // let oldfileinfo=this.rowdata
            // let newfileinfo=this.fileinfo
            this.$axios({
                method: "post",
                url: url + "filechange",
                data: formdata,
                // data: {oldfileinfo:oldfileinfo,newfileinfo:newfileinfo},
            }).then(res => {

                this.dialog = false;
                this.$message("已完成");
            })
        },

        filedelete() {
            let deleteitems = [this.rowdata]//希望得到的如[{_id:"asdfasdf",Filename:"asdf.pdf",path:""}]

            let info = { id: this.rowdata._id, deleteitems: deleteitems }
            this.$axios({
                method: "post",
                url: url + "filedelete",
                data: info,
            }).then(res => {
                this.dialog = false;
                this.$message("已删除");
            })
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/utility/commonfields/file/editfile.vue